module.exports = __webpack_public_path__ + "img/svgBandera.f1df1340.svg";